"use client";

import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const cursos = [
  "Ciência da Computação",
  "Sistemas de Informação",
  "Engenharia de Software",
  "Engenharia da Computação",
];

const diferenciais = [
  "Mentalidade voltada para IA",
  "Conhecimento básico em Spring Boot ou frameworks similares",
  "Familiaridade com Docker, GitHub, GitLab e controle de versionamento",
  "Experiência inicial com desenvolvimento em Java",
  "Noções de APIs e protocolo HTTP",
  "Conhecimento básico em estruturas de dados",
  "Conhecimento inicial em testes unitários"
];

export default function PreRequisitos() {
  const [mouseX, setMouseX] = useState(0);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMouseX((window.innerWidth / 2 - e.clientX) / 40);
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <section id="requisitos" className="bg-white py-24 relative z-10">
      <div className="container-custom">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl lg:text-[40px] font-bold text-blue-dark text-center mb-16 tracking-tight"
        >
          <span className="text-blue-main">&lt;/</span>Pré-requisitos para embarcar{" "}
          <br className="hidden md:block" />
          nessa jornada de crescimento<span className="text-blue-main">&gt;</span>
        </motion.h2>

        <div className="grid lg:grid-cols-12 gap-6 mb-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="col-span-12 lg:col-span-7 bg-blue-medium rounded-[32px] p-8 md:p-12 shadow-xl relative z-10"
          >
            <h3 className="text-2xl md:text-3xl font-bold text-secondary-main mb-6">Quem pode se candidatar:</h3>
            <ul className="space-y-6">
              <li className="text-white font-light text-lg flex gap-3">
                <span className="text-secondary-main mt-1">•</span>
                <div>
                  Maiores de 18 anos, com Graduação ou Tecnólogo em andamento ou concluído em:
                  <div className="flex flex-wrap gap-3 mt-4">
                    {cursos.map((curso, i) => (
                      <span
                        key={i}
                        className="border border-secondary-main text-secondary-main px-4 py-2 rounded-full text-sm font-medium hover:bg-secondary-main hover:text-blue-dark transition-colors cursor-default"
                      >
                        {curso}
                      </span>
                    ))}
                  </div>
                </div>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="col-span-12 lg:col-span-5 bg-blue-main rounded-[32px] p-8 md:p-12 shadow-xl flex flex-col justify-center relative z-10"
          >
            <div className="mb-8">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">Disponibilidade</h3>
              <p className="text-white font-light text-lg">
                Atuação <span className="font-bold">100% presencial</span>, de segunda a sexta-feira, das 13h30 às 17h30.
              </p>
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">Localização</h3>
              <p className="text-white font-light text-lg">
                É preciso residir em Campinas e Região.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="bg-blue-dark rounded-[32px] shadow-xl flex flex-col lg:flex-row relative z-20"
        >
          <div className="absolute inset-0 z-0 pointer-events-none opacity-85 rounded-[32px] overflow-hidden">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/images/formacao-devs-ia/Pixels.png" alt="" className="w-full h-full object-cover" />
          </div>

          <div className="p-8 md:px-12 md:py-10 lg:w-[65%] flex flex-col justify-center relative z-10">
            {/* <h3 className="text-2xl md:text-3xl font-bold text-blue-medium mb-8">
              Isso pode te diferenciar no processo:
            </h3> */}
            <ul className="space-y-4">
              {diferenciais.map((item, i) => (
                <li key={i} className="text-white font-light text-base md:text-lg flex gap-3">
                  <span className="text-secondary-main mt-1">•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:w-[35%] relative flex justify-center items-end">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              animate={{ x: mouseX }}
              transition={{ type: "spring", stiffness: 50, damping: 20 }}
              className="relative w-full h-[350px] lg:h-auto lg:absolute lg:bottom-0 lg:-mt-24 lg:right-4 z-30"
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src="/images/formacao-devs-ia/Moca-Requisitos.png"
                alt="Colaboradora Agibank"
                className="w-full h-full object-contain object-bottom drop-shadow-2xl"
              />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
